var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:_vm.classes,attrs:{"disabled":_vm.running || _vm.disabled},on:{"click":_vm.start}},'v-btn',_vm.$attrs,false),[(_vm.running)?_c('v-progress-circular',{staticClass:"mr-2",attrs:{"rotate":360,"size":25,"width":5,"value":_vm.progress}}):_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }